const getFeatureNameById = (featureId, features) => {
  const feature = features.find((f) => f.id === featureId);
  return feature ? feature.name : null;
};

export { getFeatureNameById };
